import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CONFIG from "../config";

export default function Registro() {
  const [usuario, setUsuario] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [nombre, setNombre] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMensaje("");
    setCargando(true);

    try {
      const res = await fetch(`${CONFIG.API_URL}registro.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ usuario, contrasena, nombre }),
      });

      const data = await res.json();

      if (data.success) {
        setMensaje("Usuario creado correctamente");
        setUsuario("");
        setContrasena("");
        setNombre("");
      } else {
        setError(data.message);
      }
    } catch {
      setError("Error de conexión con el servidor");
    } finally {
      setCargando(false);
    }
  };

  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      minHeight: "100vh", background: "#111B21", padding: "20px",
      fontFamily: "system-ui, sans-serif"
    }}>
      <div style={{
        background: "#0F1419", borderRadius: "28px", padding: "40px 36px",
        maxWidth: "400px", width: "100%",
        border: "1px solid #2A3942", boxShadow: "0 20px 35px -12px rgba(0,0,0,0.5)"
      }}>
        <h1 style={{
          textAlign: "center", color: "#E9EDEF", fontSize: "1.5rem", marginBottom: "4px"
        }}>Registro</h1>
        <p style={{
          textAlign: "center", color: "#8696A0", marginBottom: "32px", fontSize: "0.9rem"
        }}>Crear nuevo usuario</p>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "0.85rem", color: "#8696A0", fontWeight: 500 }}>Usuario</label>
            <input type="text" value={usuario} onChange={(e) => setUsuario(e.target.value)} required
              style={{
                background: "#2A3942", border: "1px solid #2A3942", borderRadius: "12px",
                padding: "12px 16px", fontSize: "1rem", color: "#E9EDEF", outline: "none"
              }}
              placeholder="Nombre de usuario" />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "0.85rem", color: "#8696A0", fontWeight: 500 }}>Nombre</label>
            <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} required
              style={{
                background: "#2A3942", border: "1px solid #2A3942", borderRadius: "12px",
                padding: "12px 16px", fontSize: "1rem", color: "#E9EDEF", outline: "none"
              }}
              placeholder="Nombre completo" />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "0.85rem", color: "#8696A0", fontWeight: 500 }}>Contraseña</label>
            <input type="password" value={contrasena} onChange={(e) => setContrasena(e.target.value)} required
              style={{
                background: "#2A3942", border: "1px solid #2A3942", borderRadius: "12px",
                padding: "12px 16px", fontSize: "1rem", color: "#E9EDEF", outline: "none"
              }}
              placeholder="Mínimo 6 caracteres" />
          </div>

          {error && <div style={{
            background: "rgba(220,53,69,0.1)", border: "1px solid rgba(220,53,69,0.3)",
            color: "#F5A3A3", padding: "10px 14px", borderRadius: "10px", fontSize: "0.85rem",
            textAlign: "center"
          }}>{error}</div>}

          {mensaje && <div style={{
            background: "rgba(37,211,102,0.1)", border: "1px solid rgba(37,211,102,0.3)",
            color: "#A3F5A3", padding: "10px 14px", borderRadius: "10px", fontSize: "0.85rem",
            textAlign: "center"
          }}>{mensaje}</div>}

          <button type="submit" disabled={cargando} style={{
            background: "linear-gradient(135deg, #25D366, #128C7E)", border: "none",
            borderRadius: "60px", padding: "14px", fontSize: "1rem", fontWeight: 600,
            color: "white", cursor: "pointer", marginTop: "4px", opacity: cargando ? 0.6 : 1
          }}>
            {cargando ? "Creando..." : "Crear usuario"}
          </button>

          <button type="button" onClick={() => navigate("/")}
            style={{
              background: "transparent", border: "1px solid #2A3942", borderRadius: "60px",
              padding: "12px", fontSize: "0.9rem", color: "#8696A0", cursor: "pointer"
            }}>
            Volver al login
          </button>
        </form>
      </div>
    </div>
  );
}
